import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/services/global/local-storage.service';
import { DataSharingService } from 'src/app/services/login-page/data-sharing.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';
import { MonerisIntegrationService } from 'src/app/services/moneris-integration/moneris-integration.service';

@Component({
  selector: 'app-modal-delete-creditcard',
  templateUrl: './modal-delete-creditcard.component.html',
  styleUrls: ['./modal-delete-creditcard.component.scss'],
})
export class ModalDeleteCreditcardComponent implements OnInit {
  @Input() removeAccount: any;
  @Output() cancelAction = new EventEmitter();
  @Output() successAction = new EventEmitter();
  userEmail: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private userProfileService: UserProfileService,
    private localStorageService: LocalStorageService,
    private dataSharingService: DataSharingService,
    private monerisIntegrationService: MonerisIntegrationService
  ) {}

  ngOnInit(): void {
    const email = this.localStorageService.get(window.btoa('obppusername'));
    this.userEmail = window.atob(email);
  }

  populateAccountAndConfirmRemove() {
    this.dataSharingService.IsLoadingEnabled.next(true);
    this.monerisIntegrationService.deleteCreditCard(this.removeAccount).subscribe((res) => {
        this.dataSharingService.IsLoadingEnabled.next(false);
        this.successAction.emit(res);
      },(error: any)=>{
        console.error(error);

      });
      this.activeModal.close("OK");
  }
  cancelAccountRemoval() {
    this.cancelAction.emit("");
    this.activeModal.close("Cancel");
  }
}
